import type { HttpGet } from '@/shared/infra/http'
import type { ConnectEulaStatus, GetConnectEulaStatus } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'

type ConnectEulaStatusDto = {
  required: boolean
  version: string
  docSha256: string
  body: string
}

export class EdgeGetConnectEulaStatusRepository {
  constructor(private readonly http: HttpGet) {}

  execute: GetConnectEulaStatus = async () => {
    try {
      const data = await this.http.get<ConnectEulaStatusDto>({
        url: '/connect/eula',
      })
      const status: ConnectEulaStatus = {
        required: data.required,
        version: data.version,
        docSha256: data.docSha256,
        body: data.body,
      }
      return status
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
